export enum ModeloCategoria {
    'default' = 'default',
    'pizza' = 'pizza',
    'peso' = 'peso'
}

export enum ModeloCategoriaTitulo {
    'default' = 'Itens principais',
    'pizza' = 'Pizza',
    'peso' = 'Buffet por Kg'
}